import HoverToggle from '@/shared/components/HoverToggle';
import PropTypes from 'prop-types';
import EditableNumber from '@/shared/components/editable/EditableNumber';
import React, { useMemo } from 'react';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { CanDelete, CanRead } from '@/shared/components/security';
import AuthService from '@/shared/services/AuthService';
import intlShape from '@/shared/utils/intlShape';
import messages from '../hrmMessages';

const AbsenceCounterCell = ({
  counter,
  resourceId,
  employeeId,
  userId,
  intl,
  onInitCounter,
  onDeleteCounter,
  onOpenRegistrationOverview,
  onOpenCounterDetails,
  inDays,
}) => {
  const currentUser = useMemo(() => AuthService.getUserId(), []);
  if (counter?.id) {
    const counterInfo = {
      ...counter,
      employeeId,
      resourceId,
    };
    const isCurrentUser = userId === currentUser;
    return (
      <Dropdown id={`Dropdown-${employeeId}-${resourceId}`}>
        <span className="info">
          <a
            title={intl.formatMessage(messages.CounterBalanceStartValue, {
              balanceDays: counter.balanceDays,
              balanceHours: counter.balance,
              startValueHours: counter.startValue,
              startValueDays: counter.startValueDays,
            })}
            onClick={() => onOpenCounterDetails(counterInfo)}
          >
            {inDays
              ? `${counter.balanceDays}/${counter.startValueDays}`
              : `${counter.balance}/${counter.startValue}`}
          </a>
        </span>
        <HoverToggle bsRole="toggle" />

        <Dropdown.Menu className="unselectable">
          <CanRead on={isCurrentUser ? 'RegistrationOwn' : 'RegistrationOthers'}>
            <MenuItem
              eventKey="0"
              onSelect={() => onOpenRegistrationOverview({ userId, resourceId })}
            >
              <i className="fa fa-th fa-fw margin5R" />
              <FormattedMessage {...messages.OpenRegistrationOverview} />
            </MenuItem>
          </CanRead>
          <MenuItem eventKey="0" onSelect={() => onOpenCounterDetails(counterInfo)}>
            <i className="fa fa-search fa-fw margin5R" />
            <FormattedMessage {...messages.OpenDetails} />
          </MenuItem>
          <CanDelete on="AbsenceAndCounters">
            <MenuItem eventKey="1" onSelect={() => onDeleteCounter(counterInfo)}>
              <i className="fa fa-trash fa-fw margin5R" />
              <FormattedMessage {...messages.Delete} />
            </MenuItem>
          </CanDelete>
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  // Counter not initialized
  return (
    <span title={intl.formatMessage(messages.InitializeCounter)}>
      <EditableNumber
        allowDecimals
        submitOnBlur
        onChange={value => onInitCounter({ resourceId, employeeId, startValue: value, inDays })}
        displayValue={<i className="fa fa-fw fa-plus" />}
        min={0}
        placeholder={intl.formatMessage(inDays ? messages.Days : messages.Hours)}
      />
    </span>
  );
};

AbsenceCounterCell.propTypes = {
  intl: intlShape.isRequired,
  counter: PropTypes.shape({
    id: PropTypes.string,
    balanceDays: PropTypes.number,
    balance: PropTypes.number,
    startValue: PropTypes.number,
    startValueDays: PropTypes.number,
  }),
  resourceId: PropTypes.string.isRequired,
  employeeId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  onInitCounter: PropTypes.func.isRequired,
  onDeleteCounter: PropTypes.func.isRequired,
  onOpenRegistrationOverview: PropTypes.func.isRequired,
  onOpenCounterDetails: PropTypes.func.isRequired,
  inDays: PropTypes.bool.isRequired,
};
AbsenceCounterCell.defaultProps = {
  counter: null,
};

export default AbsenceCounterCell;
